import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();

  // No token in storage at all — redirect immediately without waiting
  const hasStoredSession = Object.keys(localStorage).some(k => k.startsWith('sb-'));
  if (!loading && !user) {
    return <Navigate to="/admin/login" replace />;
  }
  if (loading && !hasStoredSession) {
    return <Navigate to="/admin/login" replace />;
  }

  return <>{children}</>;
}
